/* eslint-disable @typescript-eslint/no-explicit-any */
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';

import { formatFiltersForAPI } from 'components/Filter/utils/filters';
import type { IFiltersAPI } from 'components/Filter/utils/filters';

import { apiClient } from '../apiClient';
import type { ILeadsWorth, Status } from '../types/lead';
import type { IRequestException } from '../types/requestException';

interface ILeadsWorthProps {
    status?: Status;
    search: string;
    filterQueryParams: IFiltersAPI;
}

export interface IGetLeadsWorthProps
    extends UseQueryOptions<ILeadsWorth, IRequestException>,
        ILeadsWorthProps {}

export const getLeadsWorth = async ({
    status,
    search,
    filterQueryParams,
}: ILeadsWorthProps) => {
    const response = await apiClient.post(
        'property-leads/estimated-market-value',
        {
            json: {
                status: status ?? '',
                search,
                ...filterQueryParams,
            },
        }
    );
    return (await response.json()) as ILeadsWorth;
};

export const useGetLeadsWorthQuery = ({
    status,
    search,
    activeFilters,
    ...options
}: any) => {
    const filterQueryParams = activeFilters
        ? formatFiltersForAPI(activeFilters)
        : {};

    return useQuery<ILeadsWorth, IRequestException>(
        ['property-leads-worth', status, activeFilters],
        async () => await getLeadsWorth({ status, search, filterQueryParams }),
        {
            ...options,
        }
    );
};
